<template>
  <div class='register-page'>
    <register></register>
  </div>
</template>

<script>
  import Register from '@/components/Register';
  import firebase from "firebase";
  const fb = require('../firebaseConfig.js');
  const db = fb.default.db;

export default {
  name: 'loginregister',
  components: {
    'register': Register
  },
  data(){
    return {
    }
  },
  mounted(){
  },
  created() {
  },
}
</script>

<style lang='scss'>
  .register-page .capture .contain {
    padding-top: 150px;
  }
</style>
